import {
  WidgetContactFormFieldType,
  WidgetContactFormMode
} from 'widget/entities/config';

export const WidgetTexts = {
  shared: {
    clearButton: 'Очистить',
    closeButton: 'Закрыть',
    dropdown: {
      searchPlaceholder: 'Поиск...',
      emptyText: 'Ничего не найдено'
    },
    downloadFile: {
      error: {
        unknown: 'Не получилось скачать файл'
      }
    }
  },
  widgetLauncher: {
    hideUntilReload: 'Скрыть виджет до перезагрузки страницы'
  },
  preview: {
    messages: {
      bot: 'В превью можно видеть, как меняется виджет при смене настроек',
      user: 'Начнем кастомизацию',
      userGreeting: 'Привет'
    }
  },
  submissionForm: {
    title: {
      [WidgetContactFormMode.beforeDialog]: {
        title: 'Мы с вами еще не общались',
        subtitle: 'Заполните форму, чтобы начать диалог'
      },
      [WidgetContactFormMode.duringDialog]: {
        title: 'Пожалуйста, заполните форму',
        subtitle: null
      },
      [WidgetContactFormMode.disabled]: {
        title: null,
        subtitle: null
      }
    },
    fields: {
      [WidgetContactFormFieldType.name]: {
        label: 'Ваше имя',
        placeholder: 'Введите имя'
      },
      [WidgetContactFormFieldType.email]: {
        label: 'Ваш e-mail',
        placeholder: 'Введите e-mail'
      },
      [WidgetContactFormFieldType.phone]: {
        label: 'Ваш телефон',
        placeholder: '(xxx) хххххх'
      }
    },
    consents: {
      personalData: {
        label: 'Я даю согласие на обработку данных',
        forLink: 'обработку данных'
      },
      mailing: {
        label: 'Я даю согласие на получение рекламных рассылок',
        forLink: 'получение рекламных рассылок'
      }
    },
    submitButton: {
      [WidgetContactFormMode.beforeDialog]: 'Начать чат',
      [WidgetContactFormMode.duringDialog]: 'Отправить',
      [WidgetContactFormMode.disabled]: null
    }
  },
  messageList: {
    empty: 'История чата пуста, задайте интересующий вас вопрос.',
    error: {
      text: 'Сообщение не отправлено',
      retry: 'Повторить'
    }
  },
  messageForm: {
    emojiPicker: {
      label: 'Выберите эмоцию'
    },
    attachments: {
      label: 'Прикрепить файл',
      removeLabel: 'Удалить вложение',
      loading: 'Загрузка...',
      retry: 'Повторить'
    },
    dropZone: {
      placeholder: 'Перетащите файлы сюда...'
    },
    messages: {
      label: 'Отправить сообщение',
      placeholder: 'Напишите сообщение...'
    }
  },
  mediaViewer: {
    close: {
      label: 'Закрыть'
    },
    download: {
      label: 'Скачать'
    },
    previous: {
      label: 'Назад'
    },
    next: {
      label: 'Вперед'
    }
  }
} as const;
